module.exports = __webpack_public_path__ + "media/icons/phone@3x-blue-aa9d29ed.svg";